import { apiService, organizationTag } from '../api';
import { getOrganizationSettingsQuery } from './interfaces';
import { IOrganization } from '../../common/organization/interfaces';
import { defaultOrganizationSettings } from '../../common/organization/constants';
import { localStorageWrapper } from '../../functions/localStorage';

const organizationService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationSettings: builder.query<
      getOrganizationSettingsQuery['response'],
      getOrganizationSettingsQuery['request']
    >({
      async queryFn(organizationAlias, _api, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `/organization/settings/${organizationAlias}`,
          method: 'GET',
        });

        const data =
          localStorageWrapper.getOrganization() ?? defaultOrganizationSettings;

        if (result.error) {
          return { data };
        }

        if (result.data) {
          localStorageWrapper.setOrganization(JSON.stringify(result.data));
          return { data: result.data as IOrganization };
        }

        return { data };
      },
      providesTags: [organizationTag],
    }),
  }),
});

export default organizationService;
